RivalIQ.apps.Insights.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const widgetTypes = RivalIQ.enums.widgetTypes;

    const widgets = [
        {
            instanceId: 'paid-reach-notification',
            widgetId: RivalIQ.enums.widgetTypes.PAID_REACH_NOTIFICATION,
            supportedExportFormats: [],
            region: 'top'
        },
        {
            instanceId: 'additional-auth-facebook',
            widgetId: RivalIQ.enums.widgetTypes.ADDITIONAL_AUTHORIZATION,
            region: 'top',
            supportedExportFormats: [],
            props: {
                source: RivalIQ.enums.sources.FACEBOOK_INSIGHTS
            }
        },
        {
            instanceId: 'fb-ads-token-request',
            widgetId: RivalIQ.enums.widgetTypes.FB_ADS_TOKEN_REQUEST,
            region: 'top',
            supportedExportFormats: [],
            props: {
                source: RivalIQ.enums.sources.FACEBOOK_INSIGHTS
            }
        },
        {
            instanceId: 'insights-reel-details',
            widgetId: widgetTypes.FB_INSIGHTS_REEL_DETAILS,
            region: 'top'
        },
        {
            instanceId: 'insights-reel-at-a-glance',
            widgetId: widgetTypes.FB_INSIGHTS_REEL_AT_A_GLANCE,
            region: 'top'
        },
        {
            instanceId: 'insights-reel-social-engagement',
            widgetId: widgetTypes.FB_INSIGHTS_REEL_SOCIAL_ENGAGEMENT,
            region: 'top'
        },
        {
            instanceId: 'insights-reel-reactions-breakdown',
            widgetId: widgetTypes.FB_INSIGHTS_REEL_REACTIONS,
            region: 'top'
        }
    ];

    curations.FacebookInsightsReelDetailsCuration = curations.FacebookInsightsPostDetailsCuration.extend({
        buildConfiguration: function () {
            return new RivalIQ.apps.Dashboard.models.Configuration({
                definitions: widgets
            });
        }
    });

});
